:host {
  --uui-tabs-fill-evenly: 0;
  --uui-tabs-border-color: var(--uui-theme-variant-300);
  --uui-tabs-padding-left: 0;
  --uui-tabs-padding-right: 0;
}

/* Non-variable host values */
:host {
  display: flex;
}

:host([orientation="horizontal"]) {
  border-bottom: 1px solid var(--uui-tabs-border-color);
  padding-left: var(--uui-tabs-padding-left);
  padding-right: var(--uui-tabs-padding-right);
  width: 100%;
}

:host([orientation="vertical"]) {
  flex-direction: column;
}

:host([type="icon"]) {
  border-bottom: none;
  width: fit-content;
}

:host([fillevenly]) {
  --uui-tabs-fill-evenly: 1;
}

::slotted(uui-tab:last-child) {
  --uui-tab-margin-right: 0;
}

::slotted(*) {
  flex-grow: var(--uui-tabs-fill-evenly);
}